import clsx from 'clsx'
import React, { useRef } from 'react'
import {Link} from 'react-router-dom'
import {useDrag, useDrop} from 'react-dnd'
import {makeStyles} from 'external/material'
import Fade from '@mui/material/Fade'
import Box from '@mui/material/Box'
import EditableCaption from '../components/editable-caption'
import {faFolderOpen, faFolder, faCaretLeft, faCaretDown, faSort} from "@fortawesome/free-solid-svg-icons"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import AddQuestion from './add-question'
import Question from './question'

const verticalCentering = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center'
}

const useStyles = makeStyles(theme => ({
  section: {
    display: 'flex',
    flexDirection: 'column',
  },
  sectionName: {
    display: 'flex',
    borderTop: 'solid 1px #c6d6e3',
    borderBottom: 'solid 1px #c6d6e3',
    color: '#68728b',
    '& > .sortIcon': {
      fontSize: '14pt',
      padding: '0 5px 0 10px',
      color: '#d8d9dd',
      cursor: 'pointer',
      ...verticalCentering
    },
    '& > .caretIcon': {
      fontSize: '12pt',
      padding: '0 8px',
      cursor: 'pointer',
      ...verticalCentering
    },
    '& > .folderIcon': {
      marginLeft: 10,
      fontSize: '15pt',
      cursor: 'pointer',
      ...verticalCentering
    },
    '& > .label': {
      marginLeft: 10,
      textDecoration: 'none',
      fontWeight: 'bold',
      color: '#68728b',
      padding: '15px 4px',
      flexGrow: 1,
      '&:hover': {
        textDecoration: 'underline',
      },
    },
    '&.selected': {
      backgroundColor: '#1d9be5',
      '& > .label': {
        color: '#fff',
        cursor: 'default',
        '&:hover': {
          textDecoration: 'none',
        },
      },
      '& > .folderIcon': {
        color: '#fff',
      },
      '& .inputTitle': {
        color: '#fff',
      }
    }
  },
  sectionContent: {
    display: 'none',
    flexGrow: 1,
    '&.opened': {
      display: 'flex'
    }
  },
  questions: {
    flexGrow: 1
  }
}))

export default function Section (props) {

  const classes = useStyles()

  const {
    context,
    section,
    index,
    onToggleSection,
    onDeleteQuestion,
    onQuestionDropped,
    onQuestionMove,
    onTitleChange,
    onSectionMove,
    onSectionDropped,
    questions = []
  } = props

  const {translate, updateState} = context

  const {id, title, opened} = section

  const [{ isDragging }, drag, preview] = useDrag({
    item: { type: 'SECTION', id, index },
    collect: monitor => ({
      isDragging: monitor.isDragging(),
    }),
  })

  const folderRef = useRef(null)
  const [, folderDrop] = useDrop({
    accept: ['SECTION'],
    hover(item, monitor) {
      
      if (item.index == index) return

      const {current} = folderRef
      if (!current) return

      const {top, bottom} = current.getBoundingClientRect()
      const middle = (bottom - top) / 2
      const {y} = monitor.getClientOffset()
      const dY = y - top
      const goingUp = item.index > index
      if (goingUp && dY < middle) return
      if (!goingUp && dY > middle) return

      onSectionMove && onSectionMove(item.index, index)
      item.index = index

    },
    drop(item, monitor) {
      if (!monitor.didDrop()) {
        onSectionDropped && onSectionDropped()
      }
    }
  })

  folderDrop(folderRef)

  const opacity = isDragging ? 0 : 1

  const sectionLabel = `${index + 1}. ${title || translate('section')}`
  const selected = context.sectionId == id && !context.questionId
  const link = context.link({sectionId: id}, `/:languageId/:role/:page/:assessment/edit/:sectionId`)

  return (
    <Box ref={preview} style={{opacity}} className={clsx(classes.section,{selected})}>
      <Box ref={folderRef} onClick={() => onToggleSection && onToggleSection(id)} className={clsx(classes.sectionName,{selected})}>
        <Box ref={drag} className="sortIcon">
          <FontAwesomeIcon icon={faSort} />
        </Box>
        <Box className="folderIcon">
          <FontAwesomeIcon icon={opened ? faFolderOpen : faFolder} />
        </Box>
        <Link to={link} className="label" onClick={e => e.stopPropagation()}>{sectionLabel}</Link>
        <Box className="caretIcon">
          <FontAwesomeIcon icon={opened ? faCaretDown : faCaretLeft} />
        </Box>
      </Box>
      {/* <Fade in={opened}> */}
        <Box className={clsx(classes.sectionContent, {opened})}>
          <Box className={classes.questions}>
            <AddQuestion context={context} section={section} />
            {questions.map((question, index) => {
              return (
                <Question
                  key={question.id}
                  index={index}
                  question={question}
                  section={section}
                  context={context}
                  onQuestionMove={onQuestionMove}
                  onQuestionDropped={onQuestionDropped}
                  onDeleteQuestion={onDeleteQuestion}
                />)
            })}
          </Box>
        </Box>
      {/* </Fade> */}
    </Box>
  )
}
